module.exports = __webpack_public_path__ + "media/images/useek-logo-white-f178fde944ccee4ae51ea15ed2cfd3e8.png";